<template>
  <section class="bg" v-cloak>
    <div class="home-bg">
      <app-header></app-header>
      <div class="home-banner">
          <p class="logo-name"><span>Global Global Kft.</span></p>
          <p class="logo-des">{{ $t("xdata.Home_des") }}</p>
        </div>
    </div>
    <div class="home-icons">
    </div>
    <div class="home-ict u-flex u-flex-between">
        <div class="ict-item u-flex u-flex-y-center u-flex-column">
          <div class="icon-item animated flipInY u-flex u-flex-xy-center ans">
            <img src="@/assets/svg/icon1.svg">
          </div>
          <p>
            {{ $t("xdata.Home_icon_t1") }}
          </p>
        </div>
        <div class="ict-item u-flex u-flex-y-center u-flex-column">
          <div class="icon-item animated flipInY u-flex u-flex-xy-center">
            <img src="@/assets/svg/icon2.svg">
          </div>
          <p>
            {{ $t("xdata.Home_icon_t2") }}
            </p>
        </div>
        <div class="ict-item u-flex u-flex-y-center u-flex-column">
          <div class="icon-item animated flipInY u-flex u-flex-xy-center">
            <img src="@/assets/svg/icon3.svg">
          </div>
          <p>
            {{ $t("xdata.Home_icon_t3") }}
            </p>
        </div>
        <div class="ict-item u-flex u-flex-y-center u-flex-column">
          <div class="icon-item animated flipInY u-flex u-flex-xy-center">
            <img src="@/assets/svg/icon4.svg">
          </div>
          <p> {{ $t("xdata.Home_icon_t4") }}</p>
        </div>
    </div>
    <div class="home-team">
      <div class="home-team-box u-flex">
        <div class="home-team-name">
          <p> {{ $t("xdata.Home_zzjg") }}</p>
        </div>
        <div class="home-team-bar"></div>
        <div class="home-team-3 animated fadeInRightBig">
          <span class="home-team-span1"> {{ $t("xdata.Home_gl") }}</span>
          <span class="home-team-span2"> ——  {{ $t("xdata.Home_glm") }}</span>
        </div>
        <div class="home-team-2 animated fadeInRightBig">
          <span class="home-team-span1"> {{ $t("xdata.Home_xzzx") }}</span>
          <span class="home-team-span2"> ——  {{ $t("xdata.Home_xzzxm") }}</span>
        </div>
        <div class="home-team-1 animated fadeInRightBig">
          <span class="home-team-span1"> {{ $t("xdata.Home_yxzx") }}</span>
          <span class="home-team-span2"> ——  {{ $t("xdata.Home_yxzxm") }}</span>
        </div>
        <div class="home-team-4 animated fadeInRightBig">
          <span class="home-team-span1"> {{ $t("xdata.Home_kfzx") }}</span>
          <span class="home-team-span2"> ——  {{ $t("xdata.Home_kfzxm") }}</span>
        </div>
        <div class="home-team-5 animated fadeInRightBig">
          <span class="home-team-span1"> {{ $t("xdata.Home_jszc") }}</span>
          <span class="home-team-span2"> ——  {{ $t("xdata.Home_jszcm") }}</span>
        </div>
      </div>
    </div>
    <div class="home-list">
      <div class="home-list-bg">
        <div class="home-list-main u-flex">
          <div class="home-list-left-box"></div>
          <div class="home-list-right-box"></div>
        </div>
        <div class="home-list-center u-flex u-flex-xy-center">
          <div class="home-list-text-left u-flex u-flex-start u-flex-column">
            <p class="home-list-text-p1">{{ $t("xdata.Home_zyfw") }}</p>
            <!-- <p class="home-list-text-p2">{{ $t("xdata.Home_zyfwm") }}</p> -->
          </div>
          <div class="home-list-text-right u-flex u-flex-between">
            <div class="home-list-item u-flex u-flex-column u-flex-y-center">
              <img src="@/assets/svg/icon5.png" class="home-list-item-icon"/>
              <span class="home-list-item-text1">7*24 {{ $t("xdata.Home_xs") }}</span>
              <span class="home-list-item-text2">{{ $t("xdata.Home_zxkf") }}</span>
            </div>
            <div class="home-list-item u-flex u-flex-column  u-flex-y-center">
              <img src="@/assets/svg/icon6.png" class="home-list-item-icon"/>
              <span class="home-list-item-text1">{{ $t("xdata.Home_xcwh") }}</span>
              <span class="home-list-item-text2">{{ $t("xdata.Home_qgfw") }}</span>
            </div>
            <div class="home-list-item u-flex u-flex-column  u-flex-y-center">
              <img src="@/assets/svg/icon7.png" class="home-list-item-icon"/>
              <span class="home-list-item-text1">{{ $t("xdata.Home_ycwh") }}</span>
              <span class="home-list-item-text2">{{ $t("xdata.Home_wljk") }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="home-list-title" style="color: #000;">{{$t("xdata.Home_rccb")}}</p>
    <div class="home-card-box u-flex u-flex-between">
        <div class="home-card-item">
          <p class="home-card-item-title">{{$t("xdata.Home_glgb")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_glgbt1")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_glgbt2")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_glgbt3")}}</p>
        </div>
        <div class="home-card-item">
          <p class="home-card-item-title">{{$t("xdata.Home_ygjs")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_ygjst1")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_ygjst2")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_ygjst3")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_ygjst4")}}</p>
        </div>
        <div class="home-card-item">
          <p class="home-card-item-title">{{$t("xdata.Home_yghw")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_yghwt1")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_yghwt2")}}</p>
          <p class="home-card-item-text">{{$t("xdata.Home_yghwt3")}}</p>
        </div>
    </div>
    <div>
      <p class="home-list-title" style="color: #000;">{{$t("xdata.Home_hzhb")}}</p>
      <div class="seamless">
        <vue-seamless-scroll
        :data="listData"
        :class-option="defaultOption"
        >
        <ul class="u-flex">
            <li class="seamless-img-box"
              v-for="index in 11"
              :key="index"
            >
            <img :src="require('@/assets/img/partner/p' + (index + 1) + '.png')">
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
    <div style="padding-bottom: 100px;">
      <p class="home-list-title" style="color: #000;">{{$t("xdata.Home_wmdkh")}}</p>
      <div class="seamless">
        <vue-seamless-scroll
        :data="listData"
        :class-option="defaultOption"
        >
        <ul class="u-flex">
            <li class="seamless-img-box"
              v-for="index in 11"
              :key="index"
            >
            <img :src="require('@/assets/img/customer/c' + (index+1) + '.png')">
            </li>
          </ul>
        </vue-seamless-scroll>
      </div>
    </div>
    <app-footer></app-footer>
  </section>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import VueSeamlessScroll from 'vue-seamless-scroll' 

export default {
  components: {
    "app-header": Header,
    "app-footer": Footer,
    ' vue-seamless-scroll': VueSeamlessScroll
  },
  name: "index",
  data() {
    return {
      listData:[{},{}]
    };
  },
  computed: {
    defaultOption () {
      return {
          step: 0.4, // 数值越大速度滚动越快
          limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 2, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created() {
   
  },
  mounted() {
  },
  filters: {
    
  },
  methods: {
    scrollToTop() {
       // 获取当前滚动位置
       console.log(currentScroll)
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        // 使用requestAnimationFrame来平滑滚动
        window.requestAnimationFrame(this.smoothScrollToTop);
        window.scrollTo(0, currentScroll - currentScroll / 8);
      }
    }
  },
};
</script>

<style scoped>
.bg {
  background: none;
}
.animated {
  animation-duration: 2s;
  animation-fill-mode: both;
}
.home-bg {
  width: 100%;
  background: url('../assets/img/home_bg.jpg') no-repeat fixed top center / 100% auto;
}
.home-banner{
  height: 580px;
  background: rgba(0, 0, 0, 0.3);
}
/* banner */
.logo-name{
  margin: 0 auto;
  padding-top: 150px;
  width: 1200px;
  font-size: 70px;
  line-height: 87px;
  font-weight: 100;
  color: #fff;
  font-weight: lighter;
}
.logo-name span{
  color: #009DE4;
  font-weight: bold;
}
.logo-des{
  width: 1200px;
  padding-right: 500px;
  box-sizing: border-box;
  margin: 20px auto 0;
  font-size: 18px;
  color: #fff;
}
.logo-des span{
  color: #009DE4;
  font-weight: bold;
}
.down-box{
  text-align: center;
  margin-top: 194px;
}
.down-box .down-more{
  font-size: 14px;
  color: #ccc;
  display: inline-block;
  margin-bottom: 10px;
  cursor: pointer;
}
.down-box .down-btn{
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0 auto;
  cursor: pointer;
  background: #009DE4;
}
.down-box .down-btn .icon-down{
  width: 24px;
  height: 24px;
}
/* home-ict */
.home-ict{
  width: 1200px;
  margin: 0 auto;
}
.home-icons{
  width: 1200px;
  margin: 80px auto 30px;
  padding: 0 50px;
  box-sizing: border-box;
}
.icon-line{
  display: inline-block;
  width: 210px;
  height: 10px;
  border: 0;
  background: url('../assets/img/separator.png') no-repeat;
  margin-top: 65px;

}
.icon-item{
  width: 140px;
  height: 140px;
  background: #009DE4;
  flex-shrink: 0;
  border-radius: 50%;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
}
.icon-item img{
  width: 80px;
  height: 80px;
}
.home-ict .ict-item{
    width: 280px;
}
.home-ict .ict-item p{
  font-size: 14px;
  line-height: 1.5;
  color: #575451;
  margin-top: 20px;
}
/* .home-team */
.home-team{
  background: #f9f9f9;
  margin-top: 50px;
}
.home-team .home-team-box{
  width: 1200px;
  height: 500px;
  position: relative;
  margin: 0 auto;
}
.home-team .home-team-box .home-team-name{
  width: 240px;
  height: 240px;
  position: absolute;
  top: 130px;
  left: 240px;
  border-radius: 50%;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  box-shadow: 10px 0px 12px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.home-team .home-team-box .home-team-name p{

}
.home-team .home-team-box .home-team-bar{
  width: 340px;
  height: 340px;
  background-color: transparent;
  border-top: 8px solid #009DE4;
  border-radius: 300px 300px 0 0;
  transform: rotate(90deg);
  position: absolute;
  top: 70px;
  left: 260px;
}
.home-team-1{
  position: absolute;
  top: 90px;
  left: 580px;
}
.home-team-2{
  position: absolute;
  top: 160px;
  left: 660px;
}
.home-team-3{
  position: absolute;
  top: 230px;
  left: 740px;
}
.home-team-4{
  position: absolute;
  top: 300px;
  left: 660px;
}
.home-team-5{
  position: absolute;
  top: 370px;
  left: 580px;
}
.home-team-span1{
  font-weight: bold;
}
.home-team-span2{
  font-size: 14px;
}
.home-list{
  width: 100%;
  background: url('../assets/img/list_bg.jpg') no-repeat fixed top center / 100% auto;
}
.home-list-bg{
  width: 100%;
  height: 100%;
  position: relative;
}
.home-list-title{
  color: #fff;
  text-align: center;
  font-size: 30px;
  font-weight: bold;
  padding: 50px 0 20px;
}
.home-list-main{
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
}
.home-list-left-box{
  width: 40%;
  height: 500px;
  background: rgba(0, 0, 0, 0.6);
}
.home-list-right-box{
  width: 60%;
  height: 500px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 0;
}
.home-list-center{
  margin: 0 auto;
  height: 500px;
  width: 1200px;
}
.home-list-text-left{
  width: 400px;
  position: relative;
  z-index: 99;
}
.home-list-text-right{
  width: 800px;
  position: relative;
  z-index: 99;
  padding: 60px 40px 0;
  box-sizing: border-box;
}
.home-list-text-p1{
  font-size: 32px;
  color: #eee;
  font-weight: bold;
  margin-bottom: 10px;
}
.home-list-text-p2{
  color: #ccc;
  font-size: 14px;
  width: 300px;
}
.home-list-text-right{
  background: rgb(255, 255, 255, 0.5);
  height: 240px;
}
.home-card-item{
  width: 30%;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  padding: 30px 20px;
  box-sizing: border-box;
  border-radius: 8px;
}
.home-card-item-title{
  text-align: center;
  font-weight: bold;
  margin-bottom: 20px;
}
.home-card-item-text{
  line-height: 1.5;
  color: #333;  
  margin-bottom: 10px;
  font-size: 14px;
}
.home-card-pl{
  width: 1200px;
  margin: 0 auto;
}
.home-card-pl p{
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  background: #009DE4;
  display: inline-block;
  padding: 8px 10px;
}
.home-list-item{
  width: 150px;
}
.home-list-item-icon{
  width: 40px;
  height: 40px;
}
.home-list-item-text1{
  font-size: 14px;
  margin-top: 6px;
  line-height: 1.5;
  font-weight: bold
}
.home-list-item-text2{
  font-size: 14px;
  margin-top: 6px;
  line-height: 1.5;
}


.home-card-box{
  width: 1200px;
  margin: 40px auto;
}
.seamless{
  width: 1200px;
  margin: 20px auto;
  overflow: hidden;
  padding: 10px 0;
}
.seamless-img-box{
  width: 200px;
  height: 100px;
  border: 1px solid #f4f4f4;
  margin-right: 20px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}
.seamless-img-box img{
  width: 200px;
  height: 100px;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/views/homepage.vue